import styled from 'styled-components';
import { useEffect } from 'react';
import AssociativeCardGrid from '../AssociativeCardGrid';
import { AssociativeCardObj } from '../AssociativeCard';

type Props = {
   cards: AssociativeCardObj[] | null;
   handleClick: (card: AssociativeCardObj) => void;
   setNextStep: () => void;
   setFlippedCards: () => void;
}

const StepWithPositiveCards = ({ cards, handleClick, setFlippedCards }: Props) => {

   useEffect(() => {
      setFlippedCards();
   }, []);

   return (
      <StepWrapper>
         <AssociativeCardGrid cards={cards} handleClick={handleClick} />
      </StepWrapper>
   );
};

export default StepWithPositiveCards;

const StepWrapper = styled.div`
   display: flex;
   flex-direction: column;
   text-align: right;
   align-items: end;
   padding: 1rem;
`;
